
import { Component, Prop, Watch, mixins } from 'nuxt-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { validations } from '@/mixins/validationJobApply'
import { AlertType, JobType, ModalThemeType } from '@/models/enums'
import Mixin from '@/mixins'
import SettingsModule from '@/store/settings'
import JobsModule from '@/store/jobs'
import UserModule from '@/store/user'
import { removeClassListPopup, getFormData } from '@/utils'
import { showSweetalert } from '@/utils/showAlert'

@Component({
  name: 'DialogApplyWithOutCv',
  validations,
})
export default class DialogApplyWithoutCV extends mixins(Mixin) {
  isVisible: boolean = getModule(SettingsModule, this.$store)
    .isVisibleDialogWithOutCV

  isLoading: boolean = false
  isSubmitting: boolean = false
  btnStyleLoading: object = {
    visibility: 'visible',
    opacity: 1,
  }

  form: any = {
    display_name: this.userProfile.full_name,
    email: this.userProfile.email,
    phone: this.userProfile.phone,
  }

  submitStyle: object = { pointerEvents: 'none', opacity: 0.7 }

  @Prop({ required: true, type: Number }) readonly id: number
  @Prop({ type: String }) title: string
  @Prop({ type: String }) companyName: string
  @Prop({ type: String }) jobTypeStr: string

  @Watch('isVisible', { immediate: true, deep: true })
  isVisibleChanged() {
    return getModule(SettingsModule, this.$store).isVisibleDialogWithOutCV
  }

  get isAuth(): boolean {
    return getModule(UserModule, this.$store).isAuth
  }

  get userProfile(): any {
    return getModule(UserModule, this.$store).profile
  }

  handleCloseDialog(): void {
    getModule(SettingsModule, this.$store).showDialogWithOutCV(false)
    removeClassListPopup('layer-popup')
  }

  async handleApplyJob() {
    // eslint-disable-next-line camelcase
    const { email, phone, display_name } = this.form

    const SID =
      this.$route.query.sid &&
      (typeof this.$route.query.sid === 'string'
        ? this.$route.query.sid
        : this.$route.query.sid[0])

    const data: any = this._.omitBy(
      {
        display_name,
        email,
        phone,
        job_id: this.id,
        case: 'ApplyWithOutCv',
        sid: SID ?? null,
        utm_source: this.$route.query.utm_source,
        utm_medium: this.$route.query.utm_medium,
        utm_campaign: this.$route.query.utm_campaign,
      },
      this._.isNil
    )

    this.isSubmitting = true

    this.$v.$touch()

    if (this.$v.$invalid) {
      return
    }

    const bodyFormData = getFormData(data)

    this.isLoading = true
    await this.$repositories.jobs
      .applyJobsApi(bodyFormData)
      .then(async (response: any) => {
        this.isSubmitting = false
        this.isLoading = false
        this.handleCloseDialog()
        await getModule(JobsModule, this.$store).setNewJob({
          jobId: this.id,
          caseType: JobType.apply,
        })

        const data = response.data
        const comebackUrl = data?.data?.comeback_url
        // eslint-disable-next-line eqeqeq
        if (data.message == 'apply_success' && data.success == true) {
          const { app } = this.$nuxt.context

          app.$gtm.push({
            event: 'eec.sendCV',
            ecommerce: {
              checkout: {
                actionField: { list: 'ApplyWithoutCV' },
                products: [
                  {
                    name: this.getCurrentFullUrl(),
                    id: this.id,
                    brand: this.companyName,
                    category: 'Job',
                    variant: this.jobTypeStr,
                  },
                ],
              },
            },
          })
          this.$cookies.set('recently_apply', this.id)

          this.$repositories.activities.tracking({
            job_ids: this.id,
            collection: 'click-ok-when-sent-cv',
          })

          getModule(SettingsModule, this.$store).showDialogNotification(true)
          getModule(SettingsModule, this.$store).setDataNotification({
            email: email,
            status: data.success,
            comebackUrl: comebackUrl,
            theme: ModalThemeType.theme_noti_applay,
            event: '',
          })

          // showSweetalert({
          //   icon: AlertType.success,
          //   title: this.$i18n.t('common.congratulations'),
          //   html:
          //     '<span id="Apply_Success_Without_CV">' +
          //     this.$i18n.t('text.notification_apply_succeeded') +
          //     '</span>',
          //   confirmButtonText: this.$t('text.view_more_jobs'),
          //   allowOutsideClick: false,
          //   customClass: {
          //     confirmButton: 'btn-apply-cv-success-see-more-job',
          //   },
          // }).then((response) => {
          //   this.$repositories.activities.tracking({
          //     job_ids: this.id,
          //     collection: 'click-ok-when-sent-cv',
          //   })
          //   if (response.isConfirmed) {
          //     document.location.href = comebackUrl
          //       ? comebackUrl
          //       : document.location.origin +
          //         (this.$t('routes.it_jobs_home') as string)
          //   }
          // })
          // eslint-disable-next-line eqeqeq
        } else if (data.message == 'applied' && data.success == false) {
          showSweetalert({
            icon: AlertType.error,
            title: this.$i18n.t('common.error'),
            text: this.$i18n.t('text.you_have_applied_for_job'),
          })
        }
      })
      .catch((error: any) => {
        this.isSubmitting = false
        this.isLoading = false
        this.handleCloseDialog()
        showSweetalert({
          icon: AlertType.error,
          title: this.$i18n.t('common.sorry'),
          text: this.$i18n.t('text.notification_apply_failed'),
        })
        console.log(error)
      })
  }
}
